import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { StpMaterialModule } from '../material/material.module';

@NgModule({
  imports: [
    CommonModule,
    StpMaterialModule
  ],
  exports: [
    CheckboxComponent
  ],
  declarations: [
    CheckboxComponent
  ]
})
export class StpCheckboxModule { }
